import * as React from 'react'
import { SFC } from 'react'
import { Button, Typography } from 'material-ui'
import { noop } from 'lodash'

export const BigGreenButton: SFC<{
    text: string
    onClick?: () => void
}> = ({text, onClick}) => (
    <Button
        color='contrast'
        onClick={onClick || noop}
        style={{
            padding: '20px 70px',
            borderRadius: 30,
            marginTop: 35,
            textTransform: 'none',
            background: 'linear-gradient(-225deg, #62A744 0%, #6CCC31 100%)'
        }}
    >
        <Typography type='title' style={{color: '#fff'}}>
            {text}
        </Typography>
    </Button>
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/BigGreenButton.tsx